import { HttpTypes } from '@/types';
import { IStoreInfoData } from '@/types/general';
import { AxiosInstance } from 'axios';

class StoreInfo {
  private client: AxiosInstance;
  private routePath = '/sites';
  public host = '';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async get(): Promise<HttpTypes.IResponse<IStoreInfoData>> {
    const result = await this.client.get(`${this.routePath}/store-info`, {
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default StoreInfo;
